import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const ItrCheckCredentialsInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-key', title: 'ITR Check Credentials', subtitle: 'Validate Income Tax portal credentials for an ITR client' }}
        fields={[
            { name: 'client_id', label: 'Client ID', icon: 'pi-key', placeholder: 'itr_xxxxxxxxxxxxx', maxLength: 100, mono: true,
              colClass: 'col-12 md:col-8 lg:col-6' },
        ]}
        endpoint={{
            path: '/surepass/itr/check-credentials',
            bodyMapper: (v, sid) => ({ client_id: v.client_id.trim(), api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="itr-check-credentials"
        submitLabel="Check Credentials"
        successSummary="Credentials checked"
        errorSummary="Credential check failed"
        confirmHeader="Confirm credential check"
        confirmAcceptLabel="Yes, check"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'ITR Credentials', icon: 'pi-key' }}
    />
);

export default ItrCheckCredentialsInputComponent;
